import React, { lazy } from 'react';
export function PainPoints() {
  return <article className="prose prose-lg max-w-none font-serif text-[#1a1a1a] mb-12" data-id="element-211">
      <p className="mb-6 text-[18px] leading-relaxed drop-cap" data-id="element-212">
        It's not the pain that changes your life. It's the hesitation. It
        happens right before the step. Before the curb. Before the stairs.
        Before walking across the uneven parking lot.
      </p>

      <blockquote className="pull-quote text-[22px] leading-tight my-8" data-id="element-213">
        "The split-second thought: What if it gives out?"
      </blockquote>

      <p className="mb-6 text-[18px] leading-relaxed" data-id="element-214">
        And that's how life gets smaller. Quietly. Not because you "can't" do
        things anymore, but because your knee feels unpredictable. It might be
        stiff when you first stand up, wobbly at random moments, or fine one day
        and completely uncooperative the next.
      </p>

      <p className="mb-6 text-[18px] leading-relaxed" data-id="element-215">
        If this sounds familiar, I want you to know something important: You're
        not crazy. You're not lazy. And you're certainly not failing at
        willpower.
      </p>

      <p className="mb-6 text-[18px] leading-relaxed font-medium text-[#8B2500]" data-id="element-216">
        You're simply dealing with a geometry problem.
      </p>
    </article>;
}